var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("g-breadcrumb", {
        attrs: { paginas: _vm.paginaStatus.caminhoMigalha }
      }),
      _c(
        "q-card",
        [
          _c("q-card-main", [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-sm-12 col-xs-12" },
                [
                  _c("g-select", {
                    ref: "refRelatorios",
                    attrs: {
                      id: "refRelatorios",
                      name: "refRelatorios",
                      etiqueta: "Relatórios",
                      foco: false,
                      itens: _vm.relatoriosArray,
                      "item-valor": "codigo",
                      "item-etiqueta": "descricao",
                      desabilitar: _vm.paginaStatus.desabilitarEdicao
                    },
                    model: {
                      value: _vm.relatorio,
                      callback: function($$v) {
                        _vm.relatorio = $$v
                      },
                      expression: "relatorio"
                    }
                  })
                ],
                1
              )
            ]),
            _vm.relatorio == "ROTEIROS_DOS_PROCESSOS"
              ? _c("span", [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-sm-4 col-xs-4" },
                      [
                        _c("g-autocomplete", {
                          ref: "refTipoProcesso",
                          attrs: {
                            id: "refTipoProcesso",
                            name: "refTipoProcesso",
                            etiqueta: "Tipo de Processo",
                            descricaoPrimaria: "desTipoProcesso",
                            valor: "codTipoProcesso",
                            foco: false,
                            api: _vm.apiTipoProcesso
                          },
                          model: {
                            value: _vm.codTipoProcesso,
                            callback: function($$v) {
                              _vm.codTipoProcesso = $$v
                            },
                            expression: "codTipoProcesso"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-sm-4 col-xs-4" },
                      [
                        _c("g-autocomplete", {
                          ref: "refAssunto",
                          attrs: {
                            id: "refAssunto",
                            name: "refAssunto",
                            etiqueta: "Assunto",
                            valor: "codAssunto",
                            descricaoPrimaria: "desAssunto",
                            foco: false,
                            api: _vm.apiAssunto,
                            desabilitar: _vm.desabilitarAssunto
                          },
                          model: {
                            value: _vm.codAssunto,
                            callback: function($$v) {
                              _vm.codAssunto = $$v
                            },
                            expression: "codAssunto"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-sm-4 col-xs-4" },
                      [
                        _c("g-autocomplete", {
                          ref: "refSubAssunto",
                          attrs: {
                            id: "refSubAssunto",
                            name: "refSubAssunto",
                            etiqueta: "Subassunto",
                            valor: "codSubassunto",
                            descricaoPrimaria: "desSubassunto",
                            api: _vm.apiSubAssunto,
                            foco: false,
                            desabilitar: _vm.desabilitarSubAssunto,
                            filtroAdicional: _vm.filtroPesquisaSubAssunto
                          },
                          model: {
                            value: _vm.codSubassunto,
                            callback: function($$v) {
                              _vm.codSubassunto = $$v
                            },
                            expression: "codSubassunto"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ])
              : _vm._e(),
            _vm.relatorio == "COMPROVANTE_ENCAMINHAMENTO_PROCESSO"
              ? _c("span", [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-sm-3 col-xs-3" },
                      [
                        _c("g-input", {
                          ref: "refnumInicialProcesso",
                          attrs: {
                            id: "refnumInicialProcesso",
                            name: "refnumInicialProcesso",
                            validacao: "Number",
                            mascara: "numero",
                            tamanho: 10,
                            etiqueta: "Nº Processo Inicial",
                            foco: false,
                            chamarFuncaoNoEnter: _vm.pesquisarPrimeiraPagina
                          },
                          model: {
                            value: _vm.numInicialProcesso,
                            callback: function($$v) {
                              _vm.numInicialProcesso = $$v
                            },
                            expression: "numInicialProcesso"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-sm-3 col-xs-3" },
                      [
                        _c("g-input", {
                          ref: "refnumFinalProcesso",
                          attrs: {
                            id: "refnumFinalProcesso",
                            name: "refnumFinalProcesso",
                            validacao: "Number",
                            mascara: "numero",
                            tamanho: 10,
                            etiqueta: "Nº Processo Final",
                            foco: false,
                            chamarFuncaoNoEnter: _vm.pesquisarPrimeiraPagina
                          },
                          model: {
                            value: _vm.numFinalProcesso,
                            callback: function($$v) {
                              _vm.numFinalProcesso = $$v
                            },
                            expression: "numFinalProcesso"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "col-sm-3 col-xs-3",
                        staticStyle: { "padding-right": "30px" }
                      },
                      [
                        _c("g-dateInput", {
                          ref: "refDataMovimentacaoInicial",
                          attrs: {
                            id: "refDataMovimentacaoInicial",
                            name: "refDataMovimentacaoInicial",
                            etiqueta: "Data Inicial",
                            desabilitar: false,
                            somenteLeitura: _vm.paginaStatus.desabilitarEdicao,
                            dataMax: new Date()
                          },
                          model: {
                            value: _vm.dataInicial,
                            callback: function($$v) {
                              _vm.dataInicial = $$v
                            },
                            expression: "dataInicial"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "col-sm-3 col-xs-3",
                        staticStyle: { "padding-right": "30px" }
                      },
                      [
                        _c("g-dateInput", {
                          ref: "refDatAtualizacaoFinal",
                          attrs: {
                            id: "refDatAtualizacaoFinal",
                            name: "refDatAtualizacaoFinal",
                            etiqueta: "Data Final",
                            desabilitar: false,
                            somenteLeitura: _vm.paginaStatus.desabilitarEdicao,
                            dataMax: new Date()
                          },
                          model: {
                            value: _vm.dataFinal,
                            callback: function($$v) {
                              _vm.dataFinal = $$v
                            },
                            expression: "dataFinal"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-sm-12 col-xs-12" },
                      [
                        _c("g-autocomplete", {
                          ref: "refRequerente",
                          attrs: {
                            id: "refRequerente",
                            name: "refRequerente",
                            etiqueta: "Requerente",
                            valor: "codRequerente",
                            foco: false,
                            descricaoPrimaria: "nomeDataNascimentoDocumento",
                            desabilitar: _vm.paginaStatus.desabilitarEdicao,
                            api: _vm.apiRequerente,
                            chamarFuncaoNoEnter: _vm.pesquisarPrimeiraPagina
                          },
                          model: {
                            value: _vm.requerente.codRequerente,
                            callback: function($$v) {
                              _vm.$set(_vm.requerente, "codRequerente", $$v)
                            },
                            expression: "requerente.codRequerente"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ])
              : _vm._e(),
            _vm.relatorio == "COMPROVANTE_MOVIMENTACAO_PROCESSO"
              ? _c("span", [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-sm-3 col-xs-3" },
                      [
                        _c("g-input", {
                          ref: "refnumInicialProcesso",
                          attrs: {
                            id: "refnumInicialProcesso",
                            tipo: "text",
                            validacao: "Number",
                            mascara: "numero",
                            tamanho: 10,
                            etiqueta: "Nº Processo Inicial",
                            foco: false,
                            chamarFuncaoNoEnter: _vm.pesquisarPrimeiraPagina
                          },
                          model: {
                            value: _vm.numInicialProcesso,
                            callback: function($$v) {
                              _vm.numInicialProcesso = $$v
                            },
                            expression: "numInicialProcesso"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-sm-3 col-xs-3" },
                      [
                        _c("g-input", {
                          ref: "refnumFinalProcesso",
                          attrs: {
                            id: "refnumFinalProcesso",
                            name: "refnumFinalProcesso",
                            tipo: "text",
                            validacao: "Number",
                            mascara: "numero",
                            tamanho: 10,
                            etiqueta: "Nº Processo Final",
                            foco: false,
                            chamarFuncaoNoEnter: _vm.pesquisarPrimeiraPagina
                          },
                          model: {
                            value: _vm.numFinalProcesso,
                            callback: function($$v) {
                              _vm.numFinalProcesso = $$v
                            },
                            expression: "numFinalProcesso"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "col-sm-3 col-xs-3",
                        staticStyle: { "padding-right": "30px" }
                      },
                      [
                        _c("g-dateInput", {
                          ref: "refDataMovimentacaoInicial",
                          attrs: {
                            id: "refDataMovimentacaoInicial",
                            name: "refDataMovimentacaoInicial",
                            etiqueta: "Data Inicial",
                            desabilitar: false,
                            somenteLeitura: _vm.paginaStatus.desabilitarEdicao,
                            dataMax: new Date()
                          },
                          model: {
                            value: _vm.dataInicial,
                            callback: function($$v) {
                              _vm.dataInicial = $$v
                            },
                            expression: "dataInicial"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "col-sm-3 col-xs-3",
                        staticStyle: { "padding-right": "30px" }
                      },
                      [
                        _c("g-dateInput", {
                          ref: "refDatAtualizacaoFinal",
                          attrs: {
                            id: "refDatAtualizacaoFinal",
                            name: "refDatAtualizacaoFinal",
                            etiqueta: "Data Final",
                            desabilitar: false,
                            somenteLeitura: _vm.paginaStatus.desabilitarEdicao,
                            dataMax: new Date()
                          },
                          model: {
                            value: _vm.dataFinal,
                            callback: function($$v) {
                              _vm.dataFinal = $$v
                            },
                            expression: "dataFinal"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-sm-12 col-xs-12" },
                      [
                        _c("g-autocomplete", {
                          ref: "refRequerente",
                          attrs: {
                            id: "refRequerente",
                            name: "refRequerente",
                            etiqueta: "Requerente",
                            valor: "codRequerente",
                            foco: false,
                            descricaoPrimaria: "nomeDataNascimentoDocumento",
                            desabilitar: _vm.paginaStatus.desabilitarEdicao,
                            api: _vm.apiRequerente,
                            chamarFuncaoNoEnter: _vm.pesquisarPrimeiraPagina
                          },
                          model: {
                            value: _vm.requerente.codRequerente,
                            callback: function($$v) {
                              _vm.$set(_vm.requerente, "codRequerente", $$v)
                            },
                            expression: "requerente.codRequerente"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-sm-4 col-xs-4" },
                      [
                        _c("g-autocomplete", {
                          ref: "refOrgaoOrigem",
                          attrs: {
                            id: "refOrgaoOrigem",
                            name: "refOrgaoOrigem",
                            validacao: "text",
                            etiqueta: "Órgão de Origem",
                            valor: "codOrgao",
                            descricaoPrimaria: "desOrgao",
                            api: _vm.apiOrgao,
                            foco: false
                          },
                          model: {
                            value: _vm.codOrgaoOrigem,
                            callback: function($$v) {
                              _vm.codOrgaoOrigem = $$v
                            },
                            expression: "codOrgaoOrigem"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-sm-4 col-xs-4" },
                      [
                        _c("g-autocomplete", {
                          ref: "refUnidadeOrigem",
                          attrs: {
                            id: "refUnidadeOrigem",
                            name: "refUnidadeOrigem",
                            etiqueta: "Unidade de Origem",
                            valor: "codUnidade",
                            validacao: "text",
                            foco: false,
                            descricaoPrimaria: "desUnidade",
                            desabilitar: _vm.desabilitarUnidadeOrigem,
                            api: _vm.apiUnidade,
                            filtroAdicional: _vm.getFiltroUnidadeOrigem
                          },
                          model: {
                            value: _vm.codUnidadeOrigem,
                            callback: function($$v) {
                              _vm.codUnidadeOrigem = $$v
                            },
                            expression: "codUnidadeOrigem"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-sm-4 col-xs-4" },
                      [
                        _c("g-autocomplete", {
                          ref: "refSetorOrigem",
                          attrs: {
                            id: "refSetorOrigem",
                            name: "refSetorOrigem",
                            etiqueta: "Setor de Origem",
                            valor: "codSetor",
                            validacao: "text",
                            foco: false,
                            descricaoPrimaria: "desSetor",
                            desabilitar: _vm.desabilitarSetorOrigem,
                            api: _vm.apiSetor,
                            filtroAdicional: _vm.getFiltroSetorOrigem,
                            chamarFuncaoNoEnter: _vm.pesquisarPrimeiraPagina
                          },
                          model: {
                            value: _vm.codSetorOrigem,
                            callback: function($$v) {
                              _vm.codSetorOrigem = $$v
                            },
                            expression: "codSetorOrigem"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-sm-4 col-xs-4" },
                      [
                        _c("g-autocomplete", {
                          ref: "refOrgaoDestino",
                          attrs: {
                            id: "refOrgaoDestino",
                            name: "refOrgaoDestino",
                            validacao: "text",
                            etiqueta: "Órgão de Destino",
                            valor: "codOrgao",
                            descricaoPrimaria: "desOrgao",
                            api: _vm.apiOrgao,
                            foco: false
                          },
                          model: {
                            value: _vm.codOrgaoDestino,
                            callback: function($$v) {
                              _vm.codOrgaoDestino = $$v
                            },
                            expression: "codOrgaoDestino"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-sm-4 col-xs-4" },
                      [
                        _c("g-autocomplete", {
                          ref: "refUnidadeDestino",
                          attrs: {
                            id: "refUnidadeDestino",
                            name: "refUnidadeDestino",
                            etiqueta: "Unidade de Destino",
                            valor: "codUnidade",
                            validacao: "text",
                            foco: false,
                            descricaoPrimaria: "desUnidade",
                            desabilitar: _vm.desabilitarUnidadeDestino,
                            api: _vm.apiUnidade,
                            filtroAdicional: _vm.getFiltroUnidadeDestino
                          },
                          model: {
                            value: _vm.codUnidadeDestino,
                            callback: function($$v) {
                              _vm.codUnidadeDestino = $$v
                            },
                            expression: "codUnidadeDestino"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-sm-4 col-xs-4" },
                      [
                        _c("g-autocomplete", {
                          ref: "refSetorDestino",
                          attrs: {
                            id: "refSetorDestino",
                            name: "refSetorDestino",
                            etiqueta: "Setor de Destino",
                            valor: "codSetor",
                            validacao: "text",
                            foco: false,
                            desabilitar: _vm.desabilitarSetorDestino,
                            descricaoPrimaria: "desSetor",
                            api: _vm.apiSetor,
                            filtroAdicional: _vm.getFiltroSetorDestino,
                            chamarFuncaoNoEnter: _vm.pesquisarPrimeiraPagina
                          },
                          model: {
                            value: _vm.codSetorDestino,
                            callback: function($$v) {
                              _vm.codSetorDestino = $$v
                            },
                            expression: "codSetorDestino"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ])
              : _vm._e(),
            _vm.relatorio == "NOTIFICACAO_SOLICITACAO_COMPARECIMENTO"
              ? _c("span", [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-sm-3 col-xs-3" },
                      [
                        _c("g-input", {
                          ref: "refnumInicialProcesso",
                          attrs: {
                            id: "refnumInicialProcesso",
                            name: "refnumInicialProcesso",
                            validacao: "Number",
                            mascara: "numero",
                            tamanho: 10,
                            etiqueta: "Nº Processo Inicial",
                            foco: false,
                            chamarFuncaoNoEnter: _vm.pesquisarPrimeiraPagina
                          },
                          model: {
                            value: _vm.numInicialProcesso,
                            callback: function($$v) {
                              _vm.numInicialProcesso = $$v
                            },
                            expression: "numInicialProcesso"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-sm-3 col-xs-3" },
                      [
                        _c("g-input", {
                          ref: "refnumFinalProcesso",
                          attrs: {
                            id: "refnumFinalProcesso",
                            name: "refnumFinalProcesso",
                            validacao: "Number",
                            mascara: "numero",
                            tamanho: 10,
                            etiqueta: "Nº Processo Final",
                            foco: false,
                            chamarFuncaoNoEnter: _vm.pesquisarPrimeiraPagina
                          },
                          model: {
                            value: _vm.numFinalProcesso,
                            callback: function($$v) {
                              _vm.numFinalProcesso = $$v
                            },
                            expression: "numFinalProcesso"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "col-sm-3 col-xs-3",
                        staticStyle: { "padding-right": "30px" }
                      },
                      [
                        _c("g-dateInput", {
                          ref: "refDataMovimentacaoInicial",
                          attrs: {
                            id: "refDataMovimentacaoInicial",
                            name: "refDataMovimentacaoInicial",
                            etiqueta: "Data Inicial",
                            desabilitar: false,
                            somenteLeitura: _vm.paginaStatus.desabilitarEdicao,
                            dataMax: new Date()
                          },
                          model: {
                            value: _vm.dataInicial,
                            callback: function($$v) {
                              _vm.dataInicial = $$v
                            },
                            expression: "dataInicial"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "col-sm-3 col-xs-3",
                        staticStyle: { "padding-right": "30px" }
                      },
                      [
                        _c("g-dateInput", {
                          ref: "refDatAtualizacaoFinal",
                          attrs: {
                            id: "refDatAtualizacaoFinal",
                            name: "refDatAtualizacaoFinal",
                            etiqueta: "Data Final",
                            desabilitar: false,
                            somenteLeitura: _vm.paginaStatus.desabilitarEdicao,
                            dataMax: new Date()
                          },
                          model: {
                            value: _vm.dataFinal,
                            callback: function($$v) {
                              _vm.dataFinal = $$v
                            },
                            expression: "dataFinal"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-sm-12 col-xs-12" },
                      [
                        _c("g-autocomplete", {
                          ref: "refRequerente",
                          attrs: {
                            id: "refRequerente",
                            name: "refRequerente",
                            etiqueta: "Requerente",
                            valor: "codRequerente",
                            foco: false,
                            descricaoPrimaria: "nomeDataNascimentoDocumento",
                            desabilitar: _vm.paginaStatus.desabilitarEdicao,
                            api: _vm.apiRequerente,
                            chamarFuncaoNoEnter: _vm.pesquisarPrimeiraPagina
                          },
                          model: {
                            value: _vm.requerente.codRequerente,
                            callback: function($$v) {
                              _vm.$set(_vm.requerente, "codRequerente", $$v)
                            },
                            expression: "requerente.codRequerente"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ])
              : _vm._e(),
            _vm.relatorio == "NOTIFICACAO_COMUNICADO_SITUACAO_PROCESSO"
              ? _c("span", [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-sm-3 col-xs-3" },
                      [
                        _c("g-input", {
                          ref: "refnumInicialProcesso",
                          attrs: {
                            id: "refnumInicialProcesso",
                            name: "refnumInicialProcesso",
                            validacao: "Number",
                            mascara: "numero",
                            tamanho: 10,
                            etiqueta: "Nº Processo Inicial",
                            foco: false,
                            chamarFuncaoNoEnter: _vm.pesquisarPrimeiraPagina
                          },
                          model: {
                            value: _vm.numInicialProcesso,
                            callback: function($$v) {
                              _vm.numInicialProcesso = $$v
                            },
                            expression: "numInicialProcesso"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-sm-3 col-xs-3" },
                      [
                        _c("g-input", {
                          ref: "refnumFinalProcesso",
                          attrs: {
                            id: "refnumFinalProcesso",
                            name: "refnumFinalProcesso",
                            validacao: "Number",
                            mascara: "numero",
                            tamanho: 10,
                            etiqueta: "Nº Processo Final",
                            foco: false,
                            chamarFuncaoNoEnter: _vm.pesquisarPrimeiraPagina
                          },
                          model: {
                            value: _vm.numFinalProcesso,
                            callback: function($$v) {
                              _vm.numFinalProcesso = $$v
                            },
                            expression: "numFinalProcesso"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "col-sm-3 col-xs-3",
                        staticStyle: { "padding-right": "30px" }
                      },
                      [
                        _c("g-dateInput", {
                          ref: "refDataMovimentacaoInicial",
                          attrs: {
                            id: "refDataMovimentacaoInicial",
                            name: "refDataMovimentacaoInicial",
                            etiqueta: "Data Inicial",
                            desabilitar: false,
                            somenteLeitura: _vm.paginaStatus.desabilitarEdicao,
                            dataMax: new Date()
                          },
                          model: {
                            value: _vm.dataInicial,
                            callback: function($$v) {
                              _vm.dataInicial = $$v
                            },
                            expression: "dataInicial"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "col-sm-3 col-xs-3",
                        staticStyle: { "padding-right": "30px" }
                      },
                      [
                        _c("g-dateInput", {
                          ref: "refDatAtualizacaoFinal",
                          attrs: {
                            id: "refDatAtualizacaoFinal",
                            name: "refDatAtualizacaoFinal",
                            etiqueta: "Data Final",
                            desabilitar: false,
                            somenteLeitura: _vm.paginaStatus.desabilitarEdicao,
                            dataMax: new Date()
                          },
                          model: {
                            value: _vm.dataFinal,
                            callback: function($$v) {
                              _vm.dataFinal = $$v
                            },
                            expression: "dataFinal"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-sm-12 col-xs-12" },
                      [
                        _c("g-autocomplete", {
                          ref: "refRequerente",
                          attrs: {
                            id: "refRequerente",
                            name: "refRequerente",
                            etiqueta: "Requerente",
                            valor: "codRequerente",
                            foco: false,
                            descricaoPrimaria: "nomeDataNascimentoDocumento",
                            desabilitar: _vm.paginaStatus.desabilitarEdicao,
                            api: _vm.apiRequerente,
                            chamarFuncaoNoEnter: _vm.pesquisarPrimeiraPagina
                          },
                          model: {
                            value: _vm.requerente.codRequerente,
                            callback: function($$v) {
                              _vm.$set(_vm.requerente, "codRequerente", $$v)
                            },
                            expression: "requerente.codRequerente"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ])
              : _vm._e(),
            _vm.relatorio == "RELATORIO_GERAL_PROCESSOS"
              ? _c("span", [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-sm-3 col-xs-3" },
                      [
                        _c("g-input", {
                          ref: "refnumInicialProcesso",
                          attrs: {
                            id: "refnumInicialProcesso",
                            name: "refnumInicialProcesso",
                            tipo: "text",
                            validacao: "Number",
                            mascara: "numero",
                            tamanho: 10,
                            etiqueta: "Nº Processo Inicial",
                            foco: false,
                            chamarFuncaoNoEnter: _vm.pesquisarPrimeiraPagina
                          },
                          model: {
                            value: _vm.numInicialProcesso,
                            callback: function($$v) {
                              _vm.numInicialProcesso = $$v
                            },
                            expression: "numInicialProcesso"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-sm-3 col-xs-3" },
                      [
                        _c("g-input", {
                          ref: "refnumFinalProcesso",
                          attrs: {
                            id: "refnumFinalProcesso",
                            name: "refnumFinalProcesso",
                            tipo: "text",
                            validacao: "Number",
                            mascara: "numero",
                            tamanho: 10,
                            etiqueta: "Nº Processo Final",
                            foco: false,
                            chamarFuncaoNoEnter: _vm.pesquisarPrimeiraPagina
                          },
                          model: {
                            value: _vm.numFinalProcesso,
                            callback: function($$v) {
                              _vm.numFinalProcesso = $$v
                            },
                            expression: "numFinalProcesso"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-sm-3 col-xs-3" },
                      [
                        _c("g-input", {
                          ref: "refAnoProcessoInicial",
                          attrs: {
                            id: "refAnoProcessoInicial",
                            name: "refAnoProcessoInicial",
                            tipo: "text",
                            validacao: "Number",
                            mascara: "numero",
                            tamanho: 4,
                            etiqueta: "Ano Inicial",
                            foco: false,
                            chamarFuncaoNoEnter: _vm.pesquisarPrimeiraPagina
                          },
                          model: {
                            value: _vm.anoInicial,
                            callback: function($$v) {
                              _vm.anoInicial = $$v
                            },
                            expression: "anoInicial"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-sm-3 col-xs-3" },
                      [
                        _c("g-input", {
                          ref: "refAnoProcessoFinal",
                          attrs: {
                            id: "refAnoProcessoFinal",
                            name: "refAnoProcessoFinal",
                            tipo: "text",
                            validacao: "Number",
                            mascara: "numero",
                            tamanho: 4,
                            etiqueta: "Ano Final",
                            foco: false,
                            chamarFuncaoNoEnter: _vm.pesquisarPrimeiraPagina
                          },
                          model: {
                            value: _vm.anoFinal,
                            callback: function($$v) {
                              _vm.anoFinal = $$v
                            },
                            expression: "anoFinal"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      {
                        staticClass: "col-sm-3 col-xs-3",
                        staticStyle: { "padding-right": "30px" }
                      },
                      [
                        _c("g-dateInput", {
                          ref: "refDataMovimentacaoInicial",
                          attrs: {
                            id: "refDataMovimentacaoInicial",
                            name: "refDataMovimentacaoInicial",
                            etiqueta: "Data Inicial",
                            desabilitar: false,
                            somenteLeitura: _vm.paginaStatus.desabilitarEdicao,
                            dataMax: new Date()
                          },
                          model: {
                            value: _vm.dataInicial,
                            callback: function($$v) {
                              _vm.dataInicial = $$v
                            },
                            expression: "dataInicial"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "col-sm-3 col-xs-3",
                        staticStyle: { "padding-right": "30px" }
                      },
                      [
                        _c("g-dateInput", {
                          ref: "refDatAtualizacaoFinal",
                          attrs: {
                            id: "refDatAtualizacaoFinal",
                            name: "refDatAtualizacaoFinal",
                            etiqueta: "Data Final",
                            desabilitar: false,
                            somenteLeitura: _vm.paginaStatus.desabilitarEdicao,
                            dataMax: new Date()
                          },
                          model: {
                            value: _vm.dataFinal,
                            callback: function($$v) {
                              _vm.dataFinal = $$v
                            },
                            expression: "dataFinal"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-sm-6 col-xs-6" },
                      [
                        _c("g-select", {
                          ref: "refProcesso",
                          attrs: {
                            id: "refProcesso",
                            name: "refProcesso",
                            etiqueta: "Status Atual",
                            foco: false,
                            itens: _vm.statusProcessoSemConfirmadoArray,
                            "item-valor": "codigo",
                            "item-etiqueta": "descricao",
                            desabilitar: _vm.paginaStatus.desabilitarEdicao
                          },
                          model: {
                            value: _vm.indStatusProcesso,
                            callback: function($$v) {
                              _vm.indStatusProcesso = $$v
                            },
                            expression: "indStatusProcesso"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-sm-6 col-xs-6" },
                      [
                        _c("g-autocomplete", {
                          ref: "refRequerente",
                          attrs: {
                            id: "refRequerente",
                            name: "refRequerente",
                            etiqueta: "Requerente",
                            valor: "codRequerente",
                            foco: false,
                            descricaoPrimaria: "nomeDataNascimentoDocumento",
                            desabilitar: _vm.paginaStatus.desabilitarEdicao,
                            api: _vm.apiRequerente,
                            chamarFuncaoNoEnter: _vm.pesquisarPrimeiraPagina
                          },
                          model: {
                            value: _vm.requerente.codRequerente,
                            callback: function($$v) {
                              _vm.$set(_vm.requerente, "codRequerente", $$v)
                            },
                            expression: "requerente.codRequerente"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-sm-6 col-xs-6" },
                      [
                        _c("g-autocomplete", {
                          ref: "refUsuarioResponsavelAbertura",
                          attrs: {
                            id: "refUsuarioResponsavelAbertura",
                            name: "refUsuarioResponsavelAbertura",
                            etiqueta: "Responsável pela abertura",
                            valor: "codUsuario",
                            validacao: "text",
                            foco: false,
                            descricaoPrimaria: "nomUsuario",
                            api: _vm.apiUsuario,
                            desabilitar: _vm.paginaStatus.desabilitarEdicao
                          },
                          model: {
                            value: _vm.codUsuarioResponsavelAbertura,
                            callback: function($$v) {
                              _vm.codUsuarioResponsavelAbertura = $$v
                            },
                            expression: "codUsuarioResponsavelAbertura"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-sm-12 col-xs-12 mrg-t-30 mrg-b-10" },
                      [
                        _c(
                          "div",
                          { staticClass: "q-gutter-sm" },
                          [
                            _c("q-radio", {
                              attrs: {
                                id: "radioLocalOrigem",
                                name: "radioLocalOrigem",
                                val: "Origem",
                                label: "Local de Origem"
                              },
                              model: {
                                value: _vm.local,
                                callback: function($$v) {
                                  _vm.local = $$v
                                },
                                expression: "local"
                              }
                            }),
                            _vm._v("\n                \n              "),
                            _c("q-radio", {
                              attrs: {
                                id: "radioLocalDestino",
                                name: "radioLocalDestino",
                                val: "Destino",
                                label: "Local de Destino"
                              },
                              model: {
                                value: _vm.local,
                                callback: function($$v) {
                                  _vm.local = $$v
                                },
                                expression: "local"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  ]),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.local == "Origem",
                          expression: "local == 'Origem'"
                        }
                      ],
                      staticClass: "row"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "col-sm-4 col-xs-4" },
                        [
                          _c("g-autocomplete", {
                            ref: "refOrgaoOrigem",
                            attrs: {
                              id: "refOrgaoOrigem",
                              name: "refOrgaoOrigem",
                              validacao: "text",
                              etiqueta: "Órgão de Origem",
                              valor: "codOrgao",
                              descricaoPrimaria: "desOrgao",
                              api: _vm.apiOrgao,
                              foco: false
                            },
                            model: {
                              value: _vm.codOrgaoOrigem,
                              callback: function($$v) {
                                _vm.codOrgaoOrigem = $$v
                              },
                              expression: "codOrgaoOrigem"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-sm-4 col-xs-4" },
                        [
                          _c("g-autocomplete", {
                            ref: "refUnidadeOrigem",
                            attrs: {
                              id: "refUnidadeOrigem",
                              name: "refUnidadeOrigem",
                              etiqueta: "Unidade de Origem",
                              valor: "codUnidade",
                              validacao: "text",
                              foco: false,
                              descricaoPrimaria: "desUnidade",
                              desabilitar: _vm.desabilitarUnidadeOrigem,
                              api: _vm.apiUnidade,
                              filtroAdicional: _vm.getFiltroUnidadeOrigem
                            },
                            model: {
                              value: _vm.codUnidadeOrigem,
                              callback: function($$v) {
                                _vm.codUnidadeOrigem = $$v
                              },
                              expression: "codUnidadeOrigem"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-sm-4 col-xs-4" },
                        [
                          _c("g-autocomplete", {
                            ref: "refSetorOrigem",
                            attrs: {
                              id: "refSetorOrigem",
                              name: "refSetorOrigem",
                              etiqueta: "Setor de Origem",
                              valor: "codSetor",
                              validacao: "text",
                              foco: false,
                              descricaoPrimaria: "desSetor",
                              desabilitar: _vm.desabilitarSetorOrigem,
                              api: _vm.apiSetor,
                              filtroAdicional: _vm.getFiltroSetorOrigem,
                              chamarFuncaoNoEnter: _vm.pesquisarPrimeiraPagina
                            },
                            model: {
                              value: _vm.codSetorOrigem,
                              callback: function($$v) {
                                _vm.codSetorOrigem = $$v
                              },
                              expression: "codSetorOrigem"
                            }
                          })
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.local == "Destino",
                          expression: "local == 'Destino'"
                        }
                      ],
                      staticClass: "row"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "col-sm-4 col-xs-4" },
                        [
                          _c("g-autocomplete", {
                            ref: "refOrgaoDestino",
                            attrs: {
                              id: "refOrgaoDestino",
                              name: "refOrgaoDestino",
                              validacao: "text",
                              etiqueta: "Órgão de Destino",
                              valor: "codOrgao",
                              descricaoPrimaria: "desOrgao",
                              api: _vm.apiOrgao,
                              foco: false
                            },
                            model: {
                              value: _vm.codOrgaoDestino,
                              callback: function($$v) {
                                _vm.codOrgaoDestino = $$v
                              },
                              expression: "codOrgaoDestino"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-sm-4 col-xs-4" },
                        [
                          _c("g-autocomplete", {
                            ref: "refUnidadeDestino",
                            attrs: {
                              id: "refUnidadeDestino",
                              name: "refUnidadeDestino",
                              etiqueta: "Unidade de Destino",
                              valor: "codUnidade",
                              validacao: "text",
                              foco: false,
                              descricaoPrimaria: "desUnidade",
                              desabilitar: _vm.desabilitarUnidadeDestino,
                              api: _vm.apiUnidade,
                              filtroAdicional: _vm.getFiltroUnidadeDestino
                            },
                            model: {
                              value: _vm.codUnidadeDestino,
                              callback: function($$v) {
                                _vm.codUnidadeDestino = $$v
                              },
                              expression: "codUnidadeDestino"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-sm-4 col-xs-4" },
                        [
                          _c("g-autocomplete", {
                            ref: "refSetorDestino",
                            attrs: {
                              id: "refSetorDestino",
                              name: "refSetorDestino",
                              etiqueta: "Setor de Destino",
                              valor: "codSetor",
                              validacao: "text",
                              foco: false,
                              desabilitar: _vm.desabilitarSetorDestino,
                              descricaoPrimaria: "desSetor",
                              api: _vm.apiSetor,
                              filtroAdicional: _vm.getFiltroSetorDestino,
                              chamarFuncaoNoEnter: _vm.pesquisarPrimeiraPagina
                            },
                            model: {
                              value: _vm.codSetorDestino,
                              callback: function($$v) {
                                _vm.codSetorDestino = $$v
                              },
                              expression: "codSetorDestino"
                            }
                          })
                        ],
                        1
                      )
                    ]
                  ),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-sm-4 col-xs-4" },
                      [
                        _c("g-autocomplete", {
                          ref: "refTipoProcesso",
                          attrs: {
                            id: "refTipoProcesso",
                            name: "refTipoProcesso",
                            etiqueta: "Tipo de Processo",
                            descricaoPrimaria: "desTipoProcesso",
                            valor: "codTipoProcesso",
                            foco: false,
                            api: _vm.apiTipoProcesso
                          },
                          model: {
                            value: _vm.codTipoProcesso,
                            callback: function($$v) {
                              _vm.codTipoProcesso = $$v
                            },
                            expression: "codTipoProcesso"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-sm-4 col-xs-4" },
                      [
                        _c("g-autocomplete", {
                          ref: "refAssunto",
                          attrs: {
                            id: "refAssunto",
                            name: "refAssunto",
                            etiqueta: "Assunto",
                            valor: "codAssunto",
                            descricaoPrimaria: "desAssunto",
                            foco: false,
                            api: _vm.apiAssunto,
                            desabilitar: _vm.desabilitarAssunto
                          },
                          model: {
                            value: _vm.codAssunto,
                            callback: function($$v) {
                              _vm.codAssunto = $$v
                            },
                            expression: "codAssunto"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-sm-4 col-xs-4" },
                      [
                        _c("g-autocomplete", {
                          ref: "refSubAssunto",
                          attrs: {
                            id: "refSubAssunto",
                            name: "refSubAssunto",
                            etiqueta: "Subassunto",
                            valor: "codSubassunto",
                            descricaoPrimaria: "desSubassunto",
                            api: _vm.apiSubAssunto,
                            foco: false,
                            desabilitar: _vm.desabilitarSubAssunto,
                            filtroAdicional: _vm.filtroPesquisaSubAssunto
                          },
                          model: {
                            value: _vm.codSubassunto,
                            callback: function($$v) {
                              _vm.codSubassunto = $$v
                            },
                            expression: "codSubassunto"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ])
              : _vm._e(),
            _vm.relatorio == "RELATORIO_OBSERVACAO_SEQUENCIA"
              ? _c("span", [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-sm-3 col-xs-3" },
                      [
                        _c("g-input", {
                          ref: "refnumInicialProcesso",
                          attrs: {
                            id: "refnumInicialProcesso",
                            name: "refnumInicialProcesso",
                            tipo: "text",
                            validacao: "Number",
                            mascara: "numero",
                            tamanho: 10,
                            etiqueta: "Nº Processo Inicial",
                            foco: false,
                            chamarFuncaoNoEnter: _vm.pesquisarPrimeiraPagina
                          },
                          model: {
                            value: _vm.numInicialProcesso,
                            callback: function($$v) {
                              _vm.numInicialProcesso = $$v
                            },
                            expression: "numInicialProcesso"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-sm-3 col-xs-3" },
                      [
                        _c("g-input", {
                          ref: "refnumFinalProcesso",
                          attrs: {
                            id: "refnumFinalProcesso",
                            name: "refnumFinalProcesso",
                            tipo: "text",
                            validacao: "Number",
                            mascara: "numero",
                            tamanho: 10,
                            etiqueta: "Nº Processo Final",
                            foco: false,
                            chamarFuncaoNoEnter: _vm.pesquisarPrimeiraPagina
                          },
                          model: {
                            value: _vm.numFinalProcesso,
                            callback: function($$v) {
                              _vm.numFinalProcesso = $$v
                            },
                            expression: "numFinalProcesso"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-sm-3 col-xs-3" },
                      [
                        _c("g-input", {
                          ref: "refAnoProcessoInicial",
                          attrs: {
                            id: "refAnoProcessoInicial",
                            name: "refAnoProcessoInicial",
                            tipo: "text",
                            validacao: "Number",
                            mascara: "numero",
                            etiqueta: "Ano Inicial",
                            tamanho: 4,
                            foco: false,
                            chamarFuncaoNoEnter: _vm.pesquisarPrimeiraPagina
                          },
                          model: {
                            value: _vm.anoInicial,
                            callback: function($$v) {
                              _vm.anoInicial = $$v
                            },
                            expression: "anoInicial"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-sm-3 col-xs-3" },
                      [
                        _c("g-input", {
                          ref: "refAnoProcessoFinal",
                          attrs: {
                            id: "refAnoProcessoFinal",
                            name: "refAnoProcessoFinal",
                            tipo: "text",
                            validacao: "Number",
                            mascara: "numero",
                            tamanho: 4,
                            etiqueta: "Ano Final",
                            foco: false,
                            chamarFuncaoNoEnter: _vm.pesquisarPrimeiraPagina
                          },
                          model: {
                            value: _vm.anoFinal,
                            callback: function($$v) {
                              _vm.anoFinal = $$v
                            },
                            expression: "anoFinal"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      {
                        staticClass: "col-sm-3 col-xs-3",
                        staticStyle: { "padding-right": "30px" }
                      },
                      [
                        _c("g-dateInput", {
                          ref: "refDataMovimentacaoInicial",
                          attrs: {
                            id: "refDataMovimentacaoInicial",
                            name: "refDataMovimentacaoInicial",
                            etiqueta: "Data Inicial",
                            desabilitar: false,
                            somenteLeitura: _vm.paginaStatus.desabilitarEdicao,
                            dataMax: new Date()
                          },
                          model: {
                            value: _vm.dataInicial,
                            callback: function($$v) {
                              _vm.dataInicial = $$v
                            },
                            expression: "dataInicial"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "col-sm-3 col-xs-3",
                        staticStyle: { "padding-right": "30px" }
                      },
                      [
                        _c("g-dateInput", {
                          ref: "refDatAtualizacaoFinal",
                          attrs: {
                            id: "refDatAtualizacaoFinal",
                            name: "refDatAtualizacaoFinal",
                            etiqueta: "Data Final",
                            desabilitar: false,
                            somenteLeitura: _vm.paginaStatus.desabilitarEdicao,
                            dataMax: new Date()
                          },
                          model: {
                            value: _vm.dataFinal,
                            callback: function($$v) {
                              _vm.dataFinal = $$v
                            },
                            expression: "dataFinal"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-sm-6 col-xs-6" },
                      [
                        _c("g-select", {
                          ref: "refProcesso",
                          attrs: {
                            id: "refProcesso",
                            name: "refProcesso",
                            etiqueta: "Status Atual",
                            foco: false,
                            itens: _vm.statusProcessoArray,
                            "item-valor": "codigo",
                            "item-etiqueta": "descricao",
                            desabilitar: _vm.paginaStatus.desabilitarEdicao
                          },
                          model: {
                            value: _vm.indStatusProcesso,
                            callback: function($$v) {
                              _vm.indStatusProcesso = $$v
                            },
                            expression: "indStatusProcesso"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-sm-6 col-xs-6" },
                      [
                        _c("g-autocomplete", {
                          ref: "refRequerente",
                          attrs: {
                            id: "refRequerente",
                            name: "refRequerente",
                            etiqueta: "Requerente",
                            valor: "codRequerente",
                            foco: false,
                            descricaoPrimaria: "nomeDataNascimentoDocumento",
                            desabilitar: _vm.paginaStatus.desabilitarEdicao,
                            api: _vm.apiRequerente,
                            chamarFuncaoNoEnter: _vm.pesquisarPrimeiraPagina
                          },
                          model: {
                            value: _vm.requerente.codRequerente,
                            callback: function($$v) {
                              _vm.$set(_vm.requerente, "codRequerente", $$v)
                            },
                            expression: "requerente.codRequerente"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-sm-6 col-xs-6" },
                      [
                        _c("g-autocomplete", {
                          ref: "refUsuarioResponsavelAbertura",
                          attrs: {
                            id: "refUsuarioResponsavelAbertura",
                            name: "refUsuarioResponsavelAbertura",
                            etiqueta: "Responsável pela abertura",
                            valor: "codUsuario",
                            validacao: "text",
                            foco: false,
                            descricaoPrimaria: "nomUsuario",
                            api: _vm.apiUsuario,
                            desabilitar: _vm.paginaStatus.desabilitarEdicao
                          },
                          model: {
                            value: _vm.codUsuarioResponsavelAbertura,
                            callback: function($$v) {
                              _vm.codUsuarioResponsavelAbertura = $$v
                            },
                            expression: "codUsuarioResponsavelAbertura"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-sm-12 col-xs-12 mrg-t-30 mrg-b-10" },
                      [
                        _c(
                          "div",
                          { staticClass: "q-gutter-sm" },
                          [
                            _c("q-radio", {
                              attrs: {
                                id: "radioLocalOrigem",
                                name: "radioLocalOrigem",
                                val: "Origem",
                                label: "Local de Origem"
                              },
                              model: {
                                value: _vm.local,
                                callback: function($$v) {
                                  _vm.local = $$v
                                },
                                expression: "local"
                              }
                            }),
                            _vm._v("\n                \n              "),
                            _c("q-radio", {
                              attrs: {
                                id: "radioLocalDestino",
                                name: "radioLocalDestino",
                                val: "Destino",
                                label: "Local de Destino"
                              },
                              model: {
                                value: _vm.local,
                                callback: function($$v) {
                                  _vm.local = $$v
                                },
                                expression: "local"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  ]),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.local == "Origem",
                          expression: "local == 'Origem'"
                        }
                      ],
                      staticClass: "row"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "col-sm-4 col-xs-4" },
                        [
                          _c("g-autocomplete", {
                            ref: "refOrgaoOrigem",
                            attrs: {
                              id: "refOrgaoOrigem",
                              name: "refOrgaoOrigem",
                              validacao: "text",
                              etiqueta: "Órgão de Origem",
                              valor: "codOrgao",
                              descricaoPrimaria: "desOrgao",
                              api: _vm.apiOrgao,
                              foco: false
                            },
                            model: {
                              value: _vm.codOrgaoOrigem,
                              callback: function($$v) {
                                _vm.codOrgaoOrigem = $$v
                              },
                              expression: "codOrgaoOrigem"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-sm-4 col-xs-4" },
                        [
                          _c("g-autocomplete", {
                            ref: "refUnidadeOrigem",
                            attrs: {
                              id: "refUnidadeOrigem",
                              name: "refUnidadeOrigem",
                              etiqueta: "Unidade de Origem",
                              valor: "codUnidade",
                              validacao: "text",
                              foco: false,
                              descricaoPrimaria: "desUnidade",
                              desabilitar: _vm.desabilitarUnidadeOrigem,
                              api: _vm.apiUnidade,
                              filtroAdicional: _vm.getFiltroUnidadeOrigem
                            },
                            model: {
                              value: _vm.codUnidadeOrigem,
                              callback: function($$v) {
                                _vm.codUnidadeOrigem = $$v
                              },
                              expression: "codUnidadeOrigem"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-sm-4 col-xs-4" },
                        [
                          _c("g-autocomplete", {
                            ref: "refSetorOrigem",
                            attrs: {
                              id: "refSetorOrigem",
                              name: "refSetorOrigem",
                              etiqueta: "Setor de Origem",
                              valor: "codSetor",
                              validacao: "text",
                              foco: false,
                              descricaoPrimaria: "desSetor",
                              desabilitar: _vm.desabilitarSetorOrigem,
                              api: _vm.apiSetor,
                              filtroAdicional: _vm.getFiltroSetorOrigem,
                              chamarFuncaoNoEnter: _vm.pesquisarPrimeiraPagina
                            },
                            model: {
                              value: _vm.codSetorOrigem,
                              callback: function($$v) {
                                _vm.codSetorOrigem = $$v
                              },
                              expression: "codSetorOrigem"
                            }
                          })
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.local == "Destino",
                          expression: "local == 'Destino'"
                        }
                      ],
                      staticClass: "row"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "col-sm-4 col-xs-4" },
                        [
                          _c("g-autocomplete", {
                            ref: "refOrgaoDestino",
                            attrs: {
                              id: "refOrgaoDestino",
                              name: "refOrgaoDestino",
                              validacao: "text",
                              etiqueta: "Órgão de Destino",
                              valor: "codOrgao",
                              descricaoPrimaria: "desOrgao",
                              api: _vm.apiOrgao,
                              foco: false
                            },
                            model: {
                              value: _vm.codOrgaoDestino,
                              callback: function($$v) {
                                _vm.codOrgaoDestino = $$v
                              },
                              expression: "codOrgaoDestino"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-sm-4 col-xs-4" },
                        [
                          _c("g-autocomplete", {
                            ref: "refUnidadeDestino",
                            attrs: {
                              id: "refUnidadeDestino",
                              name: "refUnidadeDestino",
                              etiqueta: "Unidade de Destino",
                              valor: "codUnidade",
                              validacao: "text",
                              foco: false,
                              descricaoPrimaria: "desUnidade",
                              desabilitar: _vm.desabilitarUnidadeDestino,
                              api: _vm.apiUnidade,
                              filtroAdicional: _vm.getFiltroUnidadeDestino
                            },
                            model: {
                              value: _vm.codUnidadeDestino,
                              callback: function($$v) {
                                _vm.codUnidadeDestino = $$v
                              },
                              expression: "codUnidadeDestino"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-sm-4 col-xs-4" },
                        [
                          _c("g-autocomplete", {
                            ref: "refSetorDestino",
                            attrs: {
                              id: "refSetorDestino",
                              name: "refSetorDestino",
                              etiqueta: "Setor de Destino",
                              valor: "codSetor",
                              validacao: "text",
                              foco: false,
                              desabilitar: _vm.desabilitarSetorDestino,
                              descricaoPrimaria: "desSetor",
                              api: _vm.apiSetor,
                              filtroAdicional: _vm.getFiltroSetorDestino,
                              chamarFuncaoNoEnter: _vm.pesquisarPrimeiraPagina
                            },
                            model: {
                              value: _vm.codSetorDestino,
                              callback: function($$v) {
                                _vm.codSetorDestino = $$v
                              },
                              expression: "codSetorDestino"
                            }
                          })
                        ],
                        1
                      )
                    ]
                  ),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-sm-4 col-xs-4" },
                      [
                        _c("g-autocomplete", {
                          ref: "refTipoProcesso",
                          attrs: {
                            id: "refTipoProcesso",
                            name: "refTipoProcesso",
                            etiqueta: "Tipo de Processo",
                            descricaoPrimaria: "desTipoProcesso",
                            valor: "codTipoProcesso",
                            foco: false,
                            api: _vm.apiTipoProcesso
                          },
                          model: {
                            value: _vm.codTipoProcesso,
                            callback: function($$v) {
                              _vm.codTipoProcesso = $$v
                            },
                            expression: "codTipoProcesso"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-sm-4 col-xs-4" },
                      [
                        _c("g-autocomplete", {
                          ref: "refAssunto",
                          attrs: {
                            id: "refAssunto",
                            name: "refAssunto",
                            etiqueta: "Assunto",
                            valor: "codAssunto",
                            descricaoPrimaria: "desAssunto",
                            foco: false,
                            api: _vm.apiAssunto,
                            desabilitar: _vm.desabilitarAssunto
                          },
                          model: {
                            value: _vm.codAssunto,
                            callback: function($$v) {
                              _vm.codAssunto = $$v
                            },
                            expression: "codAssunto"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-sm-4 col-xs-4" },
                      [
                        _c("g-autocomplete", {
                          ref: "refSubAssunto",
                          attrs: {
                            id: "refSubAssunto",
                            name: "refSubAssunto",
                            etiqueta: "Subassunto",
                            valor: "codSubassunto",
                            descricaoPrimaria: "desSubassunto",
                            api: _vm.apiSubAssunto,
                            foco: false,
                            desabilitar: _vm.desabilitarSubAssunto,
                            filtroAdicional: _vm.filtroPesquisaSubAssunto
                          },
                          model: {
                            value: _vm.codSubassunto,
                            callback: function($$v) {
                              _vm.codSubassunto = $$v
                            },
                            expression: "codSubassunto"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ])
              : _vm._e(),
            _vm.relatorio == "RELATORIO_MOVIMENTACAO_PROCESSOS"
              ? _c("span", [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-sm-3 col-xs-3" },
                      [
                        _c("g-input", {
                          ref: "refnumInicialProcesso",
                          attrs: {
                            id: "refnumInicialProcesso",
                            name: "refnumInicialProcesso",
                            tipo: "text",
                            validacao: "Number",
                            mascara: "numero",
                            tamanho: 10,
                            etiqueta: "Nº Processo Inicial",
                            foco: false,
                            chamarFuncaoNoEnter: _vm.pesquisarPrimeiraPagina
                          },
                          model: {
                            value: _vm.numInicialProcesso,
                            callback: function($$v) {
                              _vm.numInicialProcesso = $$v
                            },
                            expression: "numInicialProcesso"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-sm-3 col-xs-3" },
                      [
                        _c("g-input", {
                          ref: "refnumFinalProcesso",
                          attrs: {
                            id: "refnumFinalProcesso",
                            name: "refnumFinalProcesso",
                            tipo: "text",
                            validacao: "Number",
                            mascara: "numero",
                            tamanho: 10,
                            etiqueta: "Nº Processo Final",
                            foco: false,
                            chamarFuncaoNoEnter: _vm.pesquisarPrimeiraPagina
                          },
                          model: {
                            value: _vm.numFinalProcesso,
                            callback: function($$v) {
                              _vm.numFinalProcesso = $$v
                            },
                            expression: "numFinalProcesso"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-sm-3 col-xs-3" },
                      [
                        _c("g-input", {
                          ref: "refAnoProcessoInicial",
                          attrs: {
                            id: "refAnoProcessoInicial",
                            name: "refAnoProcessoInicial",
                            tipo: "text",
                            validacao: "Number",
                            mascara: "numero",
                            etiqueta: "Ano Inicial",
                            tamanho: 4,
                            foco: false,
                            chamarFuncaoNoEnter: _vm.pesquisarPrimeiraPagina
                          },
                          model: {
                            value: _vm.anoInicial,
                            callback: function($$v) {
                              _vm.anoInicial = $$v
                            },
                            expression: "anoInicial"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-sm-3 col-xs-3" },
                      [
                        _c("g-input", {
                          ref: "refAnoProcessoFinal",
                          attrs: {
                            id: "refAnoProcessoFinal",
                            name: "refAnoProcessoFinal",
                            tipo: "text",
                            validacao: "Number",
                            mascara: "numero",
                            tamanho: 4,
                            etiqueta: "Ano Final",
                            foco: false,
                            chamarFuncaoNoEnter: _vm.pesquisarPrimeiraPagina
                          },
                          model: {
                            value: _vm.anoFinal,
                            callback: function($$v) {
                              _vm.anoFinal = $$v
                            },
                            expression: "anoFinal"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      {
                        staticClass: "col-sm-3 col-xs-3",
                        staticStyle: { "padding-right": "30px" }
                      },
                      [
                        _c("g-dateInput", {
                          ref: "refDataMovimentacaoInicial",
                          attrs: {
                            id: "refDataMovimentacaoInicial",
                            name: "refDataMovimentacaoInicial",
                            etiqueta: "Data Inicial",
                            desabilitar: false,
                            somenteLeitura: _vm.paginaStatus.desabilitarEdicao,
                            dataMax: new Date()
                          },
                          model: {
                            value: _vm.dataInicial,
                            callback: function($$v) {
                              _vm.dataInicial = $$v
                            },
                            expression: "dataInicial"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "col-sm-3 col-xs-3",
                        staticStyle: { "padding-right": "30px" }
                      },
                      [
                        _c("g-dateInput", {
                          ref: "refDatAtualizacaoFinal",
                          attrs: {
                            id: "refDatAtualizacaoFinal",
                            name: "refDatAtualizacaoFinal",
                            etiqueta: "Data Final",
                            desabilitar: false,
                            somenteLeitura: _vm.paginaStatus.desabilitarEdicao,
                            dataMax: new Date()
                          },
                          model: {
                            value: _vm.dataFinal,
                            callback: function($$v) {
                              _vm.dataFinal = $$v
                            },
                            expression: "dataFinal"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-sm-6 col-xs-6" },
                      [
                        _c("g-select", {
                          ref: "refProcesso",
                          attrs: {
                            id: "refProcesso",
                            name: "refProcesso",
                            etiqueta: "Status Atual",
                            foco: false,
                            itens: _vm.statusProcessoArray,
                            "item-valor": "codigo",
                            "item-etiqueta": "descricao",
                            desabilitar: _vm.paginaStatus.desabilitarEdicao
                          },
                          model: {
                            value: _vm.indStatusProcesso,
                            callback: function($$v) {
                              _vm.indStatusProcesso = $$v
                            },
                            expression: "indStatusProcesso"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-sm-6 col-xs-6" },
                      [
                        _c("g-autocomplete", {
                          ref: "refRequerente",
                          attrs: {
                            id: "refRequerente",
                            name: "refRequerente",
                            etiqueta: "Requerente",
                            valor: "codRequerente",
                            foco: false,
                            descricaoPrimaria: "nomeDataNascimentoDocumento",
                            desabilitar: _vm.paginaStatus.desabilitarEdicao,
                            api: _vm.apiRequerente,
                            chamarFuncaoNoEnter: _vm.pesquisarPrimeiraPagina
                          },
                          model: {
                            value: _vm.requerente.codRequerente,
                            callback: function($$v) {
                              _vm.$set(_vm.requerente, "codRequerente", $$v)
                            },
                            expression: "requerente.codRequerente"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-sm-6 col-xs-6" },
                      [
                        _c("g-autocomplete", {
                          ref: "refUsuarioResponsavelAbertura",
                          attrs: {
                            id: "refUsuarioResponsavelAbertura",
                            name: "refUsuarioResponsavelAbertura",
                            etiqueta: "Responsável pela abertura",
                            valor: "codUsuario",
                            validacao: "text",
                            foco: false,
                            descricaoPrimaria: "nomUsuario",
                            api: _vm.apiUsuario,
                            desabilitar: _vm.paginaStatus.desabilitarEdicao
                          },
                          model: {
                            value: _vm.codUsuarioResponsavelAbertura,
                            callback: function($$v) {
                              _vm.codUsuarioResponsavelAbertura = $$v
                            },
                            expression: "codUsuarioResponsavelAbertura"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-sm-12 col-xs-12 mrg-t-30 mrg-b-10" },
                      [
                        _c(
                          "div",
                          { staticClass: "q-gutter-sm" },
                          [
                            _c("q-radio", {
                              attrs: {
                                id: "radioLocalOrigem",
                                name: "radioLocalOrigem",
                                val: "Origem",
                                label: "Local de Origem"
                              },
                              model: {
                                value: _vm.local,
                                callback: function($$v) {
                                  _vm.local = $$v
                                },
                                expression: "local"
                              }
                            }),
                            _vm._v("\n                \n              "),
                            _c("q-radio", {
                              attrs: {
                                id: "radioLocalDestino",
                                name: "radioLocalDestino",
                                val: "Destino",
                                label: "Local de Destino"
                              },
                              model: {
                                value: _vm.local,
                                callback: function($$v) {
                                  _vm.local = $$v
                                },
                                expression: "local"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  ]),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.local == "Origem",
                          expression: "local == 'Origem'"
                        }
                      ],
                      staticClass: "row"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "col-sm-4 col-xs-4" },
                        [
                          _c("g-autocomplete", {
                            ref: "refOrgaoOrigem",
                            attrs: {
                              id: "refOrgaoOrigem",
                              name: "refOrgaoOrigem",
                              validacao: "text",
                              etiqueta: "Órgão de Origem",
                              valor: "codOrgao",
                              descricaoPrimaria: "desOrgao",
                              api: _vm.apiOrgao,
                              foco: false
                            },
                            model: {
                              value: _vm.codOrgaoOrigem,
                              callback: function($$v) {
                                _vm.codOrgaoOrigem = $$v
                              },
                              expression: "codOrgaoOrigem"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-sm-4 col-xs-4" },
                        [
                          _c("g-autocomplete", {
                            ref: "refUnidadeOrigem",
                            attrs: {
                              id: "refUnidadeOrigem",
                              name: "refUnidadeOrigem",
                              etiqueta: "Unidade de Origem",
                              valor: "codUnidade",
                              validacao: "text",
                              foco: false,
                              descricaoPrimaria: "desUnidade",
                              desabilitar: _vm.desabilitarUnidadeOrigem,
                              api: _vm.apiUnidade,
                              filtroAdicional: _vm.getFiltroUnidadeOrigem
                            },
                            model: {
                              value: _vm.codUnidadeOrigem,
                              callback: function($$v) {
                                _vm.codUnidadeOrigem = $$v
                              },
                              expression: "codUnidadeOrigem"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-sm-4 col-xs-4" },
                        [
                          _c("g-autocomplete", {
                            ref: "refSetorOrigem",
                            attrs: {
                              id: "refSetorOrigem",
                              name: "refSetorOrigem",
                              etiqueta: "Setor de Origem",
                              valor: "codSetor",
                              validacao: "text",
                              foco: false,
                              descricaoPrimaria: "desSetor",
                              desabilitar: _vm.desabilitarSetorOrigem,
                              api: _vm.apiSetor,
                              filtroAdicional: _vm.getFiltroSetorOrigem,
                              chamarFuncaoNoEnter: _vm.pesquisarPrimeiraPagina
                            },
                            model: {
                              value: _vm.codSetorOrigem,
                              callback: function($$v) {
                                _vm.codSetorOrigem = $$v
                              },
                              expression: "codSetorOrigem"
                            }
                          })
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.local == "Destino",
                          expression: "local == 'Destino'"
                        }
                      ],
                      staticClass: "row"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "col-sm-4 col-xs-4" },
                        [
                          _c("g-autocomplete", {
                            ref: "refOrgaoDestino",
                            attrs: {
                              id: "refOrgaoDestino",
                              name: "refOrgaoDestino",
                              validacao: "text",
                              etiqueta: "Órgão de Destino",
                              valor: "codOrgao",
                              descricaoPrimaria: "desOrgao",
                              api: _vm.apiOrgao,
                              foco: false
                            },
                            model: {
                              value: _vm.codOrgaoDestino,
                              callback: function($$v) {
                                _vm.codOrgaoDestino = $$v
                              },
                              expression: "codOrgaoDestino"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-sm-4 col-xs-4" },
                        [
                          _c("g-autocomplete", {
                            ref: "refUnidadeDestino",
                            attrs: {
                              id: "refUnidadeDestino",
                              name: "refUnidadeDestino",
                              etiqueta: "Unidade de Destino",
                              valor: "codUnidade",
                              validacao: "text",
                              foco: false,
                              descricaoPrimaria: "desUnidade",
                              desabilitar: _vm.desabilitarUnidadeDestino,
                              api: _vm.apiUnidade,
                              filtroAdicional: _vm.getFiltroUnidadeDestino
                            },
                            model: {
                              value: _vm.codUnidadeDestino,
                              callback: function($$v) {
                                _vm.codUnidadeDestino = $$v
                              },
                              expression: "codUnidadeDestino"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-sm-4 col-xs-4" },
                        [
                          _c("g-autocomplete", {
                            ref: "refSetorDestino",
                            attrs: {
                              id: "refSetorDestino",
                              name: "refSetorDestino",
                              etiqueta: "Setor de Destino",
                              valor: "codSetor",
                              validacao: "text",
                              foco: false,
                              desabilitar: _vm.desabilitarSetorDestino,
                              descricaoPrimaria: "desSetor",
                              api: _vm.apiSetor,
                              filtroAdicional: _vm.getFiltroSetorDestino,
                              chamarFuncaoNoEnter: _vm.pesquisarPrimeiraPagina
                            },
                            model: {
                              value: _vm.codSetorDestino,
                              callback: function($$v) {
                                _vm.codSetorDestino = $$v
                              },
                              expression: "codSetorDestino"
                            }
                          })
                        ],
                        1
                      )
                    ]
                  ),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-sm-4 col-xs-4" },
                      [
                        _c("g-autocomplete", {
                          ref: "refTipoProcesso",
                          attrs: {
                            id: "refTipoProcesso",
                            name: "refTipoProcesso",
                            etiqueta: "Tipo de Processo",
                            descricaoPrimaria: "desTipoProcesso",
                            valor: "codTipoProcesso",
                            foco: false,
                            api: _vm.apiTipoProcesso
                          },
                          model: {
                            value: _vm.codTipoProcesso,
                            callback: function($$v) {
                              _vm.codTipoProcesso = $$v
                            },
                            expression: "codTipoProcesso"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-sm-4 col-xs-4" },
                      [
                        _c("g-autocomplete", {
                          ref: "refAssunto",
                          attrs: {
                            id: "refAssunto",
                            name: "refAssunto",
                            etiqueta: "Assunto",
                            valor: "codAssunto",
                            descricaoPrimaria: "desAssunto",
                            foco: false,
                            api: _vm.apiAssunto,
                            desabilitar: _vm.desabilitarAssunto
                          },
                          model: {
                            value: _vm.codAssunto,
                            callback: function($$v) {
                              _vm.codAssunto = $$v
                            },
                            expression: "codAssunto"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-sm-4 col-xs-4" },
                      [
                        _c("g-autocomplete", {
                          ref: "refSubAssunto",
                          attrs: {
                            id: "refSubAssunto",
                            name: "refSubAssunto",
                            etiqueta: "Subassunto",
                            valor: "codSubassunto",
                            descricaoPrimaria: "desSubassunto",
                            api: _vm.apiSubAssunto,
                            foco: false,
                            desabilitar: _vm.desabilitarSubAssunto,
                            filtroAdicional: _vm.filtroPesquisaSubAssunto
                          },
                          model: {
                            value: _vm.codSubassunto,
                            callback: function($$v) {
                              _vm.codSubassunto = $$v
                            },
                            expression: "codSubassunto"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ])
              : _vm._e(),
            _vm.relatorio == "RELATORIO_MAPA_ESTATISTICO"
              ? _c("span", [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-sm-3 col-xs-3" },
                      [
                        _c("g-input", {
                          ref: "refnumInicialProcesso",
                          attrs: {
                            id: "refnumInicialProcesso",
                            name: "refnumInicialProcesso",
                            tipo: "text",
                            validacao: "Number",
                            mascara: "numero",
                            tamanho: 10,
                            etiqueta: "Nº Processo Inicial",
                            foco: false,
                            chamarFuncaoNoEnter: _vm.pesquisarPrimeiraPagina
                          },
                          model: {
                            value: _vm.numInicialProcesso,
                            callback: function($$v) {
                              _vm.numInicialProcesso = $$v
                            },
                            expression: "numInicialProcesso"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-sm-3 col-xs-3" },
                      [
                        _c("g-input", {
                          ref: "refnumFinalProcesso",
                          attrs: {
                            id: "refnumFinalProcesso",
                            name: "refnumFinalProcesso",
                            tipo: "text",
                            validacao: "Number",
                            mascara: "numero",
                            tamanho: 10,
                            etiqueta: "Nº Processo Final",
                            foco: false,
                            chamarFuncaoNoEnter: _vm.pesquisarPrimeiraPagina
                          },
                          model: {
                            value: _vm.numFinalProcesso,
                            callback: function($$v) {
                              _vm.numFinalProcesso = $$v
                            },
                            expression: "numFinalProcesso"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-sm-3 col-xs-3" },
                      [
                        _c("g-input", {
                          ref: "refAnoProcessoInicial",
                          attrs: {
                            id: "refAnoProcessoInicial",
                            name: "refAnoProcessoInicial",
                            tipo: "text",
                            validacao: "Number",
                            mascara: "numero",
                            etiqueta: "Ano Inicial",
                            tamanho: 4,
                            foco: false,
                            chamarFuncaoNoEnter: _vm.pesquisarPrimeiraPagina
                          },
                          model: {
                            value: _vm.anoInicial,
                            callback: function($$v) {
                              _vm.anoInicial = $$v
                            },
                            expression: "anoInicial"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-sm-3 col-xs-3" },
                      [
                        _c("g-input", {
                          ref: "refAnoProcessoFinal",
                          attrs: {
                            id: "refAnoProcessoFinal",
                            name: "refAnoProcessoFinal",
                            tipo: "text",
                            validacao: "Number",
                            mascara: "numero",
                            tamanho: 4,
                            etiqueta: "Ano Final",
                            foco: false,
                            chamarFuncaoNoEnter: _vm.pesquisarPrimeiraPagina
                          },
                          model: {
                            value: _vm.anoFinal,
                            callback: function($$v) {
                              _vm.anoFinal = $$v
                            },
                            expression: "anoFinal"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-sm-6 col-xs-6" },
                      [
                        _c("g-autocomplete", {
                          ref: "refTipoProcesso",
                          attrs: {
                            id: "refTipoProcesso",
                            name: "refTipoProcesso",
                            etiqueta: "Tipo de Processo",
                            descricaoPrimaria: "desTipoProcesso",
                            valor: "codTipoProcesso",
                            foco: false,
                            api: _vm.apiTipoProcesso
                          },
                          model: {
                            value: _vm.codTipoProcesso,
                            callback: function($$v) {
                              _vm.codTipoProcesso = $$v
                            },
                            expression: "codTipoProcesso"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-sm-6 col-xs-6" },
                      [
                        _c("g-autocomplete", {
                          ref: "refRequerente",
                          attrs: {
                            id: "refRequerente",
                            name: "refRequerente",
                            etiqueta: "Requerente",
                            valor: "codRequerente",
                            foco: false,
                            descricaoPrimaria: "nomeDataNascimentoDocumento",
                            desabilitar: _vm.paginaStatus.desabilitarEdicao,
                            api: _vm.apiRequerente,
                            chamarFuncaoNoEnter: _vm.pesquisarPrimeiraPagina
                          },
                          model: {
                            value: _vm.requerente.codRequerente,
                            callback: function($$v) {
                              _vm.$set(_vm.requerente, "codRequerente", $$v)
                            },
                            expression: "requerente.codRequerente"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-sm-4 col-xs-4" },
                      [
                        _c("g-autocomplete", {
                          ref: "refOrgaoOrigem",
                          attrs: {
                            id: "refOrgaoOrigem",
                            name: "refOrgaoOrigem",
                            validacao: "text",
                            etiqueta: "Órgão de Origem",
                            valor: "codOrgao",
                            descricaoPrimaria: "desOrgao",
                            api: _vm.apiOrgao,
                            foco: false
                          },
                          model: {
                            value: _vm.codOrgaoOrigem,
                            callback: function($$v) {
                              _vm.codOrgaoOrigem = $$v
                            },
                            expression: "codOrgaoOrigem"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-sm-4 col-xs-4" },
                      [
                        _c("g-autocomplete", {
                          ref: "refUnidadeOrigem",
                          attrs: {
                            id: "refUnidadeOrigem",
                            name: "refUnidadeOrigem",
                            etiqueta: "Unidade de Origem",
                            valor: "codUnidade",
                            validacao: "text",
                            foco: false,
                            descricaoPrimaria: "desUnidade",
                            desabilitar: _vm.desabilitarUnidadeOrigem,
                            api: _vm.apiUnidade,
                            filtroAdicional: _vm.getFiltroUnidadeOrigem
                          },
                          model: {
                            value: _vm.codUnidadeOrigem,
                            callback: function($$v) {
                              _vm.codUnidadeOrigem = $$v
                            },
                            expression: "codUnidadeOrigem"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-sm-4 col-xs-4" },
                      [
                        _c("g-autocomplete", {
                          ref: "refSetorOrigem",
                          attrs: {
                            id: "refSetorOrigem",
                            name: "refSetorOrigem",
                            etiqueta: "Setor de Origem",
                            valor: "codSetor",
                            foco: false,
                            descricaoPrimaria: "desSetor",
                            desabilitar: _vm.desabilitarSetorOrigem,
                            api: _vm.apiSetor,
                            filtroAdicional: _vm.getFiltroSetorOrigem,
                            chamarFuncaoNoEnter: _vm.pesquisarPrimeiraPagina
                          },
                          model: {
                            value: _vm.codSetorOrigem,
                            callback: function($$v) {
                              _vm.codSetorOrigem = $$v
                            },
                            expression: "codSetorOrigem"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ])
              : _vm._e(),
            _vm.relatorio == "RELATORIO_PROCESSOS_INCLUIDOS_REMESSA"
              ? _c("span", [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-sm-3 col-xs-3" },
                      [
                        _c("g-input", {
                          ref: "refNumRemessaInicial",
                          attrs: {
                            id: "refNumRemessaInicial",
                            name: "refNumRemessaInicial",
                            tipo: "text",
                            etiqueta: "Nº Remessa Inicial",
                            validacao: "Number",
                            mascara: "numero",
                            tamanho: 10,
                            foco: false,
                            chamarFuncaoNoEnter: _vm.pesquisarPrimeiraPagina
                          },
                          model: {
                            value: _vm.numInicialRemessa,
                            callback: function($$v) {
                              _vm.numInicialRemessa = $$v
                            },
                            expression: "numInicialRemessa"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-sm-3 col-xs-3" },
                      [
                        _c("g-input", {
                          ref: "refNumRemessaFinal",
                          attrs: {
                            id: "refNumRemessaFinal",
                            name: "refNumRemessaFinal",
                            tipo: "text",
                            etiqueta: "Nº Remessa Final",
                            validacao: "Number",
                            mascara: "numero",
                            tamanho: 10,
                            foco: false,
                            chamarFuncaoNoEnter: _vm.pesquisarPrimeiraPagina
                          },
                          model: {
                            value: _vm.numFinalRemessa,
                            callback: function($$v) {
                              _vm.numFinalRemessa = $$v
                            },
                            expression: "numFinalRemessa"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-sm-3 col-xs-3" },
                      [
                        _c("g-input", {
                          ref: "refAnoRemessaInicial",
                          attrs: {
                            id: "refAnoRemessaInicial",
                            name: "refAnoRemessaInicial",
                            tipo: "text",
                            etiqueta: "Ano Remessa Inicial",
                            validacao: "Number",
                            mascara: "numero",
                            tamanho: 4,
                            foco: false,
                            chamarFuncaoNoEnter: _vm.pesquisarPrimeiraPagina
                          },
                          model: {
                            value: _vm.anoInicialRemessa,
                            callback: function($$v) {
                              _vm.anoInicialRemessa = $$v
                            },
                            expression: "anoInicialRemessa"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-sm-3 col-xs-3" },
                      [
                        _c("g-input", {
                          ref: "refAnoRemessaFinal",
                          attrs: {
                            id: "refAnoRemessaFinal",
                            name: "refAnoRemessaFinal",
                            tipo: "text",
                            etiqueta: "Ano Remessa Final",
                            validacao: "Number",
                            mascara: "numero",
                            tamanho: 4,
                            foco: false,
                            chamarFuncaoNoEnter: _vm.pesquisarPrimeiraPagina
                          },
                          model: {
                            value: _vm.anoFinalRemessa,
                            callback: function($$v) {
                              _vm.anoFinalRemessa = $$v
                            },
                            expression: "anoFinalRemessa"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-sm-3 col-xs-3" },
                      [
                        _c("g-input", {
                          ref: "refNumProcessoInicial",
                          attrs: {
                            id: "refNumProcessoInicial",
                            name: "refNumProcessoInicial",
                            tipo: "text",
                            etiqueta: "Nº Processo Inicial",
                            validacao: "Number",
                            mascara: "numero",
                            tamanho: 10,
                            foco: false,
                            chamarFuncaoNoEnter: _vm.pesquisarPrimeiraPagina
                          },
                          model: {
                            value: _vm.numInicialProcesso,
                            callback: function($$v) {
                              _vm.numInicialProcesso = $$v
                            },
                            expression: "numInicialProcesso"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-sm-3 col-xs-3" },
                      [
                        _c("g-input", {
                          ref: "refNumProcessoFinal",
                          attrs: {
                            id: "refNumProcessoFinal",
                            name: "refNumProcessoFinal",
                            tipo: "text",
                            etiqueta: "Nº Processo Final",
                            validacao: "Number",
                            mascara: "numero",
                            tamanho: 10,
                            foco: false,
                            chamarFuncaoNoEnter: _vm.pesquisarPrimeiraPagina
                          },
                          model: {
                            value: _vm.numFinalProcesso,
                            callback: function($$v) {
                              _vm.numFinalProcesso = $$v
                            },
                            expression: "numFinalProcesso"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-sm-3 col-xs-3" },
                      [
                        _c("g-input", {
                          ref: "refAnoProcessoInicial",
                          attrs: {
                            id: "refAnoProcessoInicial",
                            name: "refAnoProcessoInicial",
                            tipo: "text",
                            etiqueta: "Ano Processo Inicial",
                            validacao: "Number",
                            mascara: "numero",
                            tamanho: 4,
                            foco: false,
                            chamarFuncaoNoEnter: _vm.pesquisarPrimeiraPagina
                          },
                          model: {
                            value: _vm.anoInicial,
                            callback: function($$v) {
                              _vm.anoInicial = $$v
                            },
                            expression: "anoInicial"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-sm-3 col-xs-3" },
                      [
                        _c("g-input", {
                          ref: "refAnoProcessoFinal",
                          attrs: {
                            id: "refAnoProcessoFinal",
                            name: "refAnoProcessoFinal",
                            tipo: "text",
                            etiqueta: "Ano Processo Final",
                            validacao: "Number",
                            mascara: "numero",
                            tamanho: 4,
                            foco: false,
                            chamarFuncaoNoEnter: _vm.pesquisarPrimeiraPagina
                          },
                          model: {
                            value: _vm.anoFinal,
                            callback: function($$v) {
                              _vm.anoFinal = $$v
                            },
                            expression: "anoFinal"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-sm-3 col-xs-3" },
                      [
                        _c("g-select", {
                          ref: "refRemessa",
                          attrs: {
                            id: "refRemessa",
                            name: "refRemessa",
                            etiqueta: "Status",
                            foco: false,
                            itens: _vm.statusRemessaArray,
                            "item-valor": "codigo",
                            "item-etiqueta": "descricao",
                            desabilitar: _vm.paginaStatus.desabilitarEdicao
                          },
                          model: {
                            value: _vm.indStatusRemessa,
                            callback: function($$v) {
                              _vm.indStatusRemessa = $$v
                            },
                            expression: "indStatusRemessa"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ])
              : _vm._e(),
            _vm.relatorio == "RELATORIO_REMESSAS_POR_PROCESSO"
              ? _c("span", [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-sm-3 col-xs-3" },
                      [
                        _c("g-input", {
                          ref: "refNumProcessoInicial",
                          attrs: {
                            id: "refNumProcessoInicial",
                            name: "refNumProcessoInicial",
                            tipo: "text",
                            etiqueta: "Nº Processo Inicial",
                            validacao: "Number",
                            mascara: "numero",
                            tamanho: 10,
                            foco: false,
                            chamarFuncaoNoEnter: _vm.pesquisarPrimeiraPagina
                          },
                          model: {
                            value: _vm.numInicialProcesso,
                            callback: function($$v) {
                              _vm.numInicialProcesso = $$v
                            },
                            expression: "numInicialProcesso"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-sm-3 col-xs-3" },
                      [
                        _c("g-input", {
                          ref: "refNumProcessoFinal",
                          attrs: {
                            id: "refNumProcessoFinal",
                            name: "refNumProcessoFinal",
                            tipo: "text",
                            etiqueta: "Nº Processo Final",
                            validacao: "Number",
                            mascara: "numero",
                            tamanho: 10,
                            foco: false,
                            chamarFuncaoNoEnter: _vm.pesquisarPrimeiraPagina
                          },
                          model: {
                            value: _vm.numFinalProcesso,
                            callback: function($$v) {
                              _vm.numFinalProcesso = $$v
                            },
                            expression: "numFinalProcesso"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-sm-3 col-xs-3" },
                      [
                        _c("g-input", {
                          ref: "refAnoProcessoInicial",
                          attrs: {
                            id: "refAnoProcessoInicial",
                            name: "refAnoProcessoInicial",
                            tipo: "text",
                            etiqueta: "Ano Processo Inicial",
                            validacao: "Number",
                            mascara: "numero",
                            tamanho: 4,
                            foco: false,
                            chamarFuncaoNoEnter: _vm.pesquisarPrimeiraPagina
                          },
                          model: {
                            value: _vm.anoInicial,
                            callback: function($$v) {
                              _vm.anoInicial = $$v
                            },
                            expression: "anoInicial"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-sm-3 col-xs-3" },
                      [
                        _c("g-input", {
                          ref: "refAnoProcessoFinal",
                          attrs: {
                            id: "refAnoProcessoFinal",
                            name: "refAnoProcessoFinal",
                            tipo: "text",
                            etiqueta: "Ano Processo Final",
                            validacao: "Number",
                            mascara: "numero",
                            tamanho: 4,
                            foco: false,
                            chamarFuncaoNoEnter: _vm.pesquisarPrimeiraPagina
                          },
                          model: {
                            value: _vm.anoFinal,
                            callback: function($$v) {
                              _vm.anoFinal = $$v
                            },
                            expression: "anoFinal"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ])
              : _vm._e(),
            _vm.relatorio != null &&
            _vm.relatorio != undefined &&
            _vm.relatorio != ""
              ? _c("div", { staticClass: "row mrg-t-20 text-right" }, [
                  _c(
                    "div",
                    { staticClass: "col-sm-6 text-left" },
                    [
                      _c(
                        "q-btn",
                        {
                          attrs: {
                            id: "btnPesquisar",
                            name: "btnPesquisar",
                            icon: "fas fa-search",
                            color: "secondary"
                          },
                          on: { click: _vm.pesquisarPrimeiraPagina }
                        },
                        [_vm._v("  Pesquisar")]
                      ),
                      _vm._v("  \n          "),
                      _vm.exibirBotoes
                        ? _c(
                            "q-btn",
                            {
                              attrs: {
                                id: "btnLimparFiltro",
                                name: "btnLimparFiltro",
                                icon: "fa fa-eraser",
                                flat: ""
                              },
                              on: { click: _vm.limparFiltro }
                            },
                            [_vm._v("  Limpar")]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-sm-6 text-right" },
                    [
                      _vm.exibirBotoes
                        ? _c(
                            "q-btn",
                            {
                              attrs: {
                                id: "btnImprimir",
                                name: "btnImprimir",
                                icon: "fa fa-print",
                                color: "primary",
                                flat: ""
                              },
                              on: { click: _vm.imprimir }
                            },
                            [_vm._v("  Imprimir")]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.exibirDataTableRoteirosDosProcessos,
                    expression: "exibirDataTableRoteirosDosProcessos"
                  }
                ],
                staticClass: "barra-vertical-400 mrg-t-10"
              },
              [
                _c("g-datatable", {
                  ref: "refDataTableRoteirosDosProcessos",
                  attrs: {
                    id: "refDataTableRoteirosDosProcessos",
                    name: "refDataTableRoteirosDosProcessos",
                    getFiltroPesquisa: _vm.getFiltroPesquisa,
                    colunas: _vm.colunasRoteirosDosProcessos,
                    api: _vm.apiRoteirosDosProcessos,
                    operacoes: _vm.operacoesRoteirosDosProcessos,
                    exibirColunaOperacoes: _vm.exibirColunaOperacoes,
                    elementosPorPagina: _vm.elementosPorPagina,
                    carregamentoInicial: false,
                    exibirTodosElementos: true
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.exibirDataTableComprovanteEncaminhamento,
                    expression: "exibirDataTableComprovanteEncaminhamento"
                  }
                ],
                staticClass: "barra-vertical-400 mrg-t-10"
              },
              [
                _c("g-datatable", {
                  ref: "refDataTableComprovanteEncaminhamento",
                  attrs: {
                    id: "refDataTableComprovanteEncaminhamento",
                    name: "refDataTableComprovanteEncaminhamento",
                    getFiltroPesquisa: _vm.getFiltroPesquisa,
                    colunas: _vm.colunasComprovanteEncaminhamentoProcesso,
                    api: _vm.apiComprovanteEncaminhamento,
                    operacoes: _vm.operacoesComprovanteEncaminhamento,
                    exibirColunaOperacoes: _vm.exibirColunaOperacoes,
                    elementosPorPagina: _vm.elementosPorPagina,
                    carregamentoInicial: false,
                    exibirTodosElementos: true
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.exibirDataTableComprovanteMovimentacao,
                    expression: "exibirDataTableComprovanteMovimentacao"
                  }
                ],
                staticClass: "barra-vertical-400 mrg-t-10"
              },
              [
                _c("g-datatable", {
                  ref: "refDataTableComprovanteMovimentacao",
                  attrs: {
                    id: "refDataTableComprovanteMovimentacao",
                    name: "refDataTableComprovanteMovimentacao",
                    getFiltroPesquisa: _vm.getFiltroPesquisa,
                    colunas: _vm.colunasComprovanteMovimentacaoProcesso,
                    api: _vm.apiComprovanteMovimentacao,
                    operacoes: _vm.operacoesComprovanteMovimentacao,
                    exibirColunaOperacoes: _vm.exibirColunaOperacoes,
                    elementosPorPagina: _vm.elementosPorPagina,
                    carregamentoInicial: false,
                    exibirTodosElementos: true
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.exibirDataTableNotificacaoComparecimento,
                    expression: "exibirDataTableNotificacaoComparecimento"
                  }
                ],
                staticClass: "barra-vertical-400 mrg-t-10"
              },
              [
                _c("g-datatable", {
                  ref: "refDataTableNotificacaoComparecimento",
                  attrs: {
                    id: "refDataTableNotificacaoComparecimento",
                    name: "refDataTableNotificacaoComparecimento",
                    getFiltroPesquisa: _vm.getFiltroPesquisa,
                    colunas: _vm.colunasNotificacaoComparecimento,
                    api: _vm.apiNotificacaoComparecimento,
                    operacoes: _vm.operacoesNotificacaoComparecimento,
                    exibirColunaOperacoes: _vm.exibirColunaOperacoes,
                    elementosPorPagina: _vm.elementosPorPagina,
                    carregamentoInicial: false,
                    exibirTodosElementos: true
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.exibirDataTableNotificacaoComunicadoSituacaoProcesso,
                    expression:
                      "exibirDataTableNotificacaoComunicadoSituacaoProcesso"
                  }
                ],
                staticClass: "barra-vertical-400 mrg-t-10"
              },
              [
                _c("g-datatable", {
                  ref: "refDataTableNotificacaoComunicadoSituacaoProcesso",
                  attrs: {
                    id: "refDataTableNotificacaoComunicadoSituacaoProcesso",
                    name: "refDataTableNotificacaoComunicadoSituacaoProcesso",
                    getFiltroPesquisa: _vm.getFiltroPesquisa,
                    colunas: _vm.colunasNotificacaoComunicadoSituacaoProcesso,
                    api: _vm.apiNotificacaoComunicadoSituacaoProcesso,
                    operacoes:
                      _vm.operacoesNotificacaoComunicadoSituacaoProcesso,
                    exibirColunaOperacoes: _vm.exibirColunaOperacoes,
                    elementosPorPagina: _vm.elementosPorPagina,
                    carregamentoInicial: false,
                    exibirTodosElementos: true
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.exibirDataTableRelatorioGeralProcessos,
                    expression: "exibirDataTableRelatorioGeralProcessos"
                  }
                ],
                staticClass: "barra-vertical-400 mrg-t-10"
              },
              [
                _c("g-datatable", {
                  ref: "refDataTableRelatorioGeralProcessos",
                  attrs: {
                    id: "refDataTableRelatorioGeralProcessos",
                    name: "refDataTableRelatorioGeralProcessos",
                    getFiltroPesquisa: _vm.getFiltroPesquisa,
                    colunas: _vm.colunasRelatorioGeralProcessos,
                    api: _vm.apiRelatorioGeralProcessos,
                    operacoes: _vm.operacoesRelatorioGeralProcessos,
                    exibirColunaOperacoes: _vm.exibirColunaOperacoes,
                    elementosPorPagina: _vm.elementosPorPagina,
                    carregamentoInicial: false,
                    exibirTodosElementos: true
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.exibirDataTableRelatorioObservacaoSequencia,
                    expression: "exibirDataTableRelatorioObservacaoSequencia"
                  }
                ],
                staticClass: "barra-vertical-400 mrg-t-10"
              },
              [
                _c("g-datatable", {
                  ref: "refDataTableRelatorioObservacaoSequencia",
                  attrs: {
                    id: "refDataTableRelatorioObservacaoSequencia",
                    name: "refDataTableRelatorioObservacaoSequencia",
                    getFiltroPesquisa: _vm.getFiltroPesquisa,
                    colunas: _vm.colunasRelatorioObservacaoSequencia,
                    api: _vm.apiRelatorioObservacaoSequencia,
                    operacoes: _vm.operacoesRelatorioObservacaoSequencia,
                    exibirColunaOperacoes: _vm.exibirColunaOperacoes,
                    elementosPorPagina: _vm.elementosPorPagina,
                    carregamentoInicial: false,
                    exibirTodosElementos: true
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.exibirDataTableRelatorioMovimentacaoProcessos,
                    expression: "exibirDataTableRelatorioMovimentacaoProcessos"
                  }
                ],
                staticClass: "barra-vertical-400 mrg-t-10"
              },
              [
                _c("g-datatable", {
                  ref: "refDataTableRelatorioMovimentacaoProcessos",
                  attrs: {
                    id: "refDataTableRelatorioMovimentacaoProcessos",
                    name: "refDataTableRelatorioMovimentacaoProcessos",
                    getFiltroPesquisa: _vm.getFiltroPesquisa,
                    colunas: _vm.colunasRelatorioMovimentacaoProcessos,
                    api: _vm.apiRelatorioMovimentacaoProcessos,
                    operacoes: _vm.operacoesRelatorioMovimentacaoProcessos,
                    exibirColunaOperacoes: _vm.exibirColunaOperacoes,
                    elementosPorPagina: _vm.elementosPorPagina,
                    carregamentoInicial: false,
                    exibirTodosElementos: true
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.exibirDataTableRelatorioMapaEstatistico,
                    expression: "exibirDataTableRelatorioMapaEstatistico"
                  }
                ],
                staticClass: "barra-vertical-400 mrg-t-10"
              },
              [
                _c("g-datatable", {
                  ref: "refDataTableRelatorioMapaEstatistico",
                  attrs: {
                    id: "refDataTableRelatorioMapaEstatistico",
                    name: "refDataTableRelatorioMapaEstatistico",
                    getFiltroPesquisa: _vm.getFiltroPesquisa,
                    colunas: _vm.colunasRelatorioMapaEstatistico,
                    api: _vm.apiRelatorioMapaEstatistico,
                    exibirColunaOperacoes: false,
                    elementosPorPagina: _vm.elementosPorPagina,
                    carregamentoInicial: false,
                    exibirTodosElementos: true
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.exibirDataTableRelatorioProcessosIncluidosRemessa,
                    expression:
                      "exibirDataTableRelatorioProcessosIncluidosRemessa"
                  }
                ],
                staticClass: "barra-vertical-400 mrg-t-10"
              },
              [
                _c("g-datatable", {
                  ref: "refDataTableRelatorioProcessosIncluidosRemessa",
                  attrs: {
                    id: "refDataTableRelatorioProcessosIncluidosRemessa",
                    name: "refDataTableRelatorioProcessosIncluidosRemessa",
                    getFiltroPesquisa: _vm.getFiltroPesquisa,
                    colunas: _vm.colunasRelatorioProcessosIncluidosRemessa,
                    api: _vm.apiRelatorioProcessosIncluidosRemessa,
                    operacoes: _vm.operacoesRelatorioProcessosIncluidosRemessa,
                    exibirColunaOperacoes: false,
                    elementosPorPagina: _vm.elementosPorPagina,
                    carregamentoInicial: false,
                    exibirTodosElementos: true
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.exibirDataTableRelatorioRemessas,
                    expression: "exibirDataTableRelatorioRemessas"
                  }
                ],
                staticClass: "barra-vertical-400 mrg-t-10"
              },
              [
                _c("g-datatable", {
                  ref: "refDataTableRelatorioRemessasPorProcesso",
                  attrs: {
                    id: "refDataTableRelatorioRemessasPorProcesso",
                    name: "refDataTableRelatorioRemessasPorProcesso",
                    getFiltroPesquisa: _vm.getFiltroPesquisa,
                    colunas: _vm.colunasRelatorioRemessasPorProcesso,
                    api: _vm.apiRelatorioRemessas,
                    operacoes: _vm.operacoesRelatorioRemessasPorProcesso,
                    exibirColunaOperacoes: true,
                    elementosPorPagina: _vm.elementosPorPagina,
                    carregamentoInicial: false,
                    exibirTodosElementos: true
                  }
                })
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }